console.log('dddd')
const findLoadingData = async () => {
    const elements = document.querySelectorAll('.gib-loading');
    let requestData = []
    Array.from(elements).map(el => {
        if(el.getAttribute('data-variants')) {
            const variants = el.getAttribute('data-variants').split(',');
            var detailsElement = el.querySelector('script[data-variant-details]');
            var details = [];
            if (detailsElement) {
                try {
                    details = JSON.parse(detailsElement.textContent);
                } catch (error) {

                }
            } else {

            }
            variants.forEach(variantId => {
                var variantDetails = details.find(v => Number(v.id) == Number(variantId));
                var data = {
                    variantId: variantId,
                    productId: el.getAttribute('data-product'),
                    hasIcon: el.getAttribute('data-icon'),
                    alreadyInCart: "0",
                    element: el,
                    needsVariantDetailsFromSearch: !detailsElement,
                }
                if (variantDetails) {
                    data.fulfillmentService = variantDetails?.fulfillmentService ?? "hertford-warehouse";
                    data.inventoryQuantity = variantDetails?.inventoryQuantity ?? "";
                    data.inventoryPolicy = variantDetails?.inventoryPolicy ?? "";
                    data.inventoryManagement = variantDetails?.inventoryManagement ?? "";
                    data.daysToDispatch = variantDetails?.daysToDispatch ?? "";
                    data.absoluteDaysToDispatch = variantDetails?.absoluteDaysToDispatch ?? "";
                }
                requestData.push(data)
            })
        }else {
            var detailsElement = el.querySelector('script[data-variant-details]');
            var variantDetails = {};
            if (detailsElement) {
                try {
                    variantDetails = JSON.parse(detailsElement.textContent);
                } catch (error) {

                }
            }
            requestData.push({
                variantId: el.getAttribute('data-variant'),
                productId: el.getAttribute('data-product'),
                hasIcon: el.getAttribute('data-icon'),
                alreadyInCart: el.getAttribute('data-in-cart') || "0",
                element: el,
                fulfillmentService: variantDetails?.fulfillmentService ?? "hertford-warehouse",
                inventoryQuantity: variantDetails?.inventoryQuantity ?? "",
                inventoryPolicy: variantDetails?.inventoryPolicy ?? "",
                inventoryManagement: variantDetails?.inventoryManagement ?? "",
                daysToDispatch: variantDetails?.daysToDispatch ?? "",
                absoluteDaysToDispatch: variantDetails?.absoluteDaysToDispatch ?? "",
                needsVariantDetailsFromSearch: !detailsElement,
            })
        }
    })
    requestData = requestData.filter(data => data.variantId !== '' && data.productId !== '');

    await enrichVariantDetailsFromSearch(requestData);

    return requestData;
};

const enrichVariantDetailsFromSearch = async (requestData) => {
    const itemsNeedingDetails = requestData.filter(data => data.needsVariantDetailsFromSearch);
    if (itemsNeedingDetails.length === 0) {
        return;
    }

    const productIds = Array.from(new Set(itemsNeedingDetails.map(data => data.productId).filter(id => id)));
    if (productIds.length === 0) {
        return;
    }

    const query = productIds.map(id => `id:${id}`).join(' OR ');

    try {
        const searchUrl = `/search?q=${encodeURIComponent(query)}&sections=custom-variant-details`;
        const response = await fetch(searchUrl, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });

        const json = await response.json();
        if (!json['custom-variant-details']) {
            return;
        }

        const parser = new DOMParser();
        const doc = parser.parseFromString(json['custom-variant-details'], 'text/html');
        const scripts = doc.querySelectorAll('script[data-variant-details]');

        const variantDetailsByProduct = {};

        Array.from(scripts).forEach(scriptEl => {
            const productId = scriptEl.getAttribute('data-product');
            if (!productId) {
                return;
            }
            try {
                const parsed = JSON.parse(scriptEl.textContent);
                const detailsArray = Array.isArray(parsed) ? parsed : [parsed];
                variantDetailsByProduct[productId] = detailsArray;
            } catch (error) {
                console.log("error", error);
            }
        });

        console.log("variantDetailsByProduct", variantDetailsByProduct);

        itemsNeedingDetails.forEach(item => {
            const detailsArray = variantDetailsByProduct[item.productId];
            if (!detailsArray) {
                return;
            }
            const variantDetails = detailsArray.find(v => Number(v.id) == Number(item.variantId));
            if (!variantDetails) {
                return;
            }

            item.fulfillmentService = variantDetails?.fulfillmentService ?? item.fulfillmentService ?? "";
            item.inventoryQuantity = variantDetails?.inventoryQuantity ?? item.inventoryQuantity ?? "";
            item.inventoryPolicy = variantDetails?.inventoryPolicy ?? item.inventoryPolicy ?? "";
            item.inventoryManagement = variantDetails?.inventoryManagement ?? item.inventoryManagement ?? "";
            item.daysToDispatch = variantDetails?.daysToDispatch ?? item.daysToDispatch ?? "";
            item.absoluteDaysToDispatch = variantDetails?.absoluteDaysToDispatch ?? item.absoluteDaysToDispatch ?? "";
            item.needsVariantDetailsFromSearch = false;
        });

    } catch (error) {

    }
};

const getGibDates = async (requestData) => {
    const url = 'https://charterhouse-shopify-test-app.gadget.app/getDispatchDateTest';


    // Only process a maximum of 30 items
    const batch = requestData.slice(0, 80);

    const batchData = batch.map(data => ({
        product_ids: data.productId,
        variant_id: data.variantId,
        market: "22015344775",
        already_in_cart: data.alreadyInCart,
        fulfillment_service: data?.fulfillmentService ? data?.fulfillmentService : "hertford-warehouse",
        inventory_quantity: data?.inventoryQuantity ?? "",
        inventory_policy: data?.inventoryPolicy ?? "",
        inventory_management: data?.inventoryManagement ?? "",
        days_to_dispatch: data?.daysToDispatch ?? "",
        absolute_days_to_dispatch: data?.absoluteDaysToDispatch ?? "",
    }));

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(batchData),
        });

        const responseData = await response.json();

        const elementsToUpdate = []; // Collect DOM updates
        const processedElements = new Set();

        batch.forEach(item => {
            if (!item.element || processedElements.has(item.element)) return;

            const isMultiVariantCard = !!item.element.getAttribute('data-variants');
            if (isMultiVariantCard) {
                const variantsAttr = item.element.getAttribute('data-variants').split(',').map(s => s.trim());
                const matchingResponses = responseData.filter(r => variantsAttr.includes(String(r.variant_id)));
                if (matchingResponses.length > 0) {
                    const sortedData = matchingResponses.sort((a, b) => {
                        const aBest = a.in_stock && a.purchasable;
                        const bBest = b.in_stock && b.purchasable;
                        if (aBest && bBest) return 0;
                        if (aBest) return -1;
                        if (bBest) return 1;
                        if (a.purchasable && !b.purchasable) return -1;
                        if (b.purchasable && !a.purchasable) return 1;
                        return 0;
                    });
                    const bestData = sortedData[0];
                    elementsToUpdate.push(() => applyGibDate(item, bestData));
                    processedElements.add(item.element);
                }
            } else {
                const matchingResponse = responseData.find(r => String(r.variant_id) === String(item.variantId));
                if (matchingResponse) {
                    elementsToUpdate.push(() => applyGibDate(item, matchingResponse));
                    processedElements.add(item.element);
                }
            }
        });

        // Perform DOM updates all at once, in the order they appear
        elementsToUpdate.forEach(updateFn => updateFn());

    } catch (error) {
        console.error('Error in batch request:', error);
    }
};

const getContent = (data, hasIcon) => {

    let icon = "";
    if (hasIcon === "true") {
        if (data.in_stock && data.purchasable) {
            icon = `<i class="fa-fw fa-sharp fa-light fa-circle-check"></i>`;
        } else if (!data.in_stock && data.purchasable) {
            icon = `<i class="fa-fw fa-sharp fa-light fa-clock"></i>`;
        } else {
            icon = `<i class="fa-fw fa-sharp fa-light fa-times"></i>`;
        }
    }


    let content = "";
    if (data.in_stock && data.purchasable) {
        content = `<div class="gib-text gib-text--ok">${icon} Get it by ${data.pretty_earliest_delivery}</div>`;
    } else if (!data.in_stock && data.purchasable) {
        content = `<div class="gib-text gib-text--info">${icon} Stock Expected in ${data.days_to_dispatch}</div>`;
    } else {
        content = `<div class="gib-text gib-text--warn">${icon} Sold out</div>`;
    }

    return content;
}

/**
 * Apply Get It By Dates from batch response
 */
const applyGibDate = ({ element, hasIcon }, data) => {
    element.innerHTML = getContent(data, hasIcon);
    element.classList.remove("gib-loading");
};

// Override spinner icon on all gib-containers
const fixSpinnerIcons = () => {
    document.querySelectorAll('.gib-loading i').forEach(el => {
        el.className = 'fa-light fa-spinner-third fa-spin';
    });
};

const scheduleGibCheck = async () => {
    fixSpinnerIcons(); 
    const requestData = await findLoadingData();
    if (requestData.length > 0) {
        getGibDates(requestData).then(() => {
            setTimeout(scheduleGibCheck, 500); // Fetch the next batch on next cycle
        });
    } else {
        setTimeout(scheduleGibCheck, 500); // Check again after 1 second if no more elements
    }
};

const handleVariantChange = (selectedVariantId) => {
    console.log('handleVariantChange',selectedVariantId)
    if (!selectedVariantId) return;
    const elements = document.querySelectorAll('.gib-container');
    elements.forEach(element => {
        const variantId = element.getAttribute('data-variant');
        if (variantId) {
            if (String(variantId) === String(selectedVariantId)) {
                element.style.display = '';
            } else {
                element.style.display = 'none';
            }
        }
    });
};

const getSelectedVariantIdFromPage = () => {
    // 1. Check data-current-variant-id on variant wrapper or product container
    const variantWrapper = document.querySelector('[data-current-variant-id]');
    if (variantWrapper) {
        const vid = variantWrapper.getAttribute('data-current-variant-id');
        if (vid && vid !== 'null' && vid !== '') return vid;
    }

    // 2. Check master variant select or hidden id input
    const variantSelect = document.querySelector('[data-variant-select], select[name="id"], form[data-product-form] input[name="id"], .product-form input[name="id"]');
    if (variantSelect && variantSelect.value && !isNaN(variantSelect.value)) {
        return variantSelect.value;
    }

    // 3. Check URL parameter ?variant=...
    const urlParams = new URLSearchParams(window.location.search);
    const variantFromUrl = urlParams.get('variant');
    if (variantFromUrl) return variantFromUrl;

    // 4. Try checked radio button
    const checkedRadio = document.querySelector('input[type="radio"][name*="option"]:checked, input[type="radio"][name="id"]:checked');
    if (checkedRadio && checkedRadio.value && !isNaN(checkedRadio.value) && checkedRadio.value.length > 6) {
        return checkedRadio.value;
    }

    return null;
};

const setupVariantChangeListeners = () => {
    const syncVariant = () => {
        const currentId = getSelectedVariantIdFromPage();
        // if (currentId) handleVariantChange(currentId);
    };

    // Initial check
    syncVariant();

    // 1. Theme custom events
    document.addEventListener('product:variant-change', (event) => {
        if (event.detail?.variant?.id) {
            handleVariantChange(event.detail.variant.id);
        } else {
            syncVariant();
        }
    });
    document.addEventListener('variant:change', (event) => {
        if (event.detail?.variant?.id) {
            handleVariantChange(event.detail.variant.id);
        } else {
            syncVariant();
        }
    });

    // 2. Form/Input/Select changes
    document.addEventListener('change', (event) => {
        const target = event.target;
        if (!target) return;

        if (target.matches('[data-variant-select], select[name="id"], [data-current-variant-id]')) {
            handleVariantChange(target.value);
            return;
        }

        setTimeout(syncVariant, 10);
        setTimeout(syncVariant, 60);
    });

    // 3. Swatch and Option Button clicks
    document.addEventListener('click', (event) => {
        const swatchBtn = event.target.closest('[data-option-buttons] button, [data-button], .product__color-swatch, .product__chip, [data-product-option] button, .product__option button');
        if (swatchBtn) {
            setTimeout(syncVariant, 20);
            setTimeout(syncVariant, 80);
            setTimeout(syncVariant, 200);
        }
    });

    // 4. MutationObserver for data-current-variant-id changes
    const observeVariantContainers = () => {
        const containers = document.querySelectorAll('.product__variants-wrapper, [data-current-variant-id], [data-product-form], .product-form');
        containers.forEach(container => {
            const observer = new MutationObserver(() => {
                syncVariant();
            });
            observer.observe(container, {
                attributes: true,
                attributeFilter: ['data-current-variant-id', 'data-selected-value-for-option']
            });
        });
    };
    observeVariantContainers();

    // 5. Hook history replaceState & pushState for URL variant changes
    const checkVariantFromUrl = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const vid = urlParams.get('variant');
        if (vid) {
            handleVariantChange(vid);
        } else {
            syncVariant();
        }
    };

    const origReplaceState = history.replaceState;
    history.replaceState = function () {
        origReplaceState.apply(this, arguments);
        setTimeout(checkVariantFromUrl, 0);
    };

    

    const origPushState = history.pushState;
    history.pushState = function () {
        origPushState.apply(this, arguments);
        setTimeout(checkVariantFromUrl, 0);
    };

    window.addEventListener('popstate', checkVariantFromUrl);

    // 6. Dawn PubSub compatibility if present
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS?.variantChange) {
        try {
            subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
                if (event?.data?.variant?.id) handleVariantChange(event.data.variant.id);
            });
        } catch (e) {}
    }
};

window.addEventListener('DOMContentLoaded', () => {
    fixSpinnerIcons(); 
    scheduleGibCheck();
    setupVariantChangeListeners();
});
